export default {
	welcomeAddOrUpdate: '/welcome/banner/addorupdate', // 新增/编辑功能API
	welcomeDetail: '/welcome/banner/detail/{id}', // 详情API
	welcomeList: '/welcome/banner/list', // 列表API
	welcomeShowswitch: '/welcome/banner/showswitch/{id}/{showFlag}', // 显示开关操作API
	menupermissionsPart: '/iglobalwin-sso-api/menupermissions/part', // 路由权限列表,
};
